// extracted by mini-css-extract-plugin
module.exports = {"Box":"ConnectWalletButton_Box__bvIGw"};